<template>
  <div class="home-tx-detail">
    <action-bar v-if="!$route.query.hideActionBar">
      <el-button type="primary" @click="handleToHomeChart()">首页大屏</el-button>
      <div class="fill"></div>
      <subscribe-block></subscribe-block>
    </action-bar>
    <common-bg-plate v-loading="loading" :class="$route.query.hideActionBar ? 'no-action-bar' : ''">
      <detail-table :title="title1" :table-col="tableCol1" :list="list1"></detail-table>
      <detail-table :title="title2" :table-col="tableCol2" :list="list2"></detail-table>
      <detail-table :title="title3" :table-col="tableCol3" :list="list3">
        <template slot="paramsDetail">
          <param-table :head-list="labelList" :list="transParamList"></param-table>
        </template>
      </detail-table>
    </common-bg-plate>
  </div>
</template>

<script>
import subscribeBlock from '../components/subscribeBlock'
import { mapState, mapActions } from 'vuex'

import timeImg from '@/assets/images/tableIcon/time.png'
import hashImg from '@/assets/images/tableIcon/hash.png'
import heightImg from '@/assets/images/tableIcon/height.png'
import organizationImg from '@/assets/images/tableIcon/organization.png'
import statusImg from '@/assets/images/tableIcon/status-icon.png'
import startUserImg from '@/assets/images/tableIcon/start-user.png'
import idIconImg from '@/assets/images/tableIcon/id-icon.png'
import txTypeImg from '@/assets/images/tableIcon/tx-type.png'
import targetImg from '@/assets/images/tableIcon/target.png'
import resultImg from '@/assets/images/tableIcon/result.png'
import methodImg from '@/assets/images/tableIcon/method.png'
import paramsImg from '@/assets/images/tableIcon/params.png'
import contractHashImg from '@/assets/images/tableIcon/contract-hash.png'
const Base64 = require('js-base64').Base64
export default {
  name: 'TxnDetail',
  components: {
    subscribeBlock
  },
  data() {
    return {
      timeImg,
      title1: '所属区块信息',
      tableCol1: [
        { label: '区块Hash', icon: hashImg, value: 'BlockHash' },
        { label: '区块高度', icon: heightImg, value: 'blockHeight' }
      ],
      list1: {
        BlockHash: '',
        blockHeight: ''
      },
      title2: '交易信息',
      tableCol2: [
        { label: '交易id', icon: idIconImg, value: 'txId' },
        { label: '交易发送组织', icon: organizationImg, value: 'orgId' },
        { label: '交易状态', icon: statusImg, value: 'txStatusCode' },
        { label: '交易发起用户', icon: startUserImg, value: 'sender' },
        { label: '交易类型', icon: txTypeImg, value: 'txType' },
        { label: '交易发起时间', icon: timeImg, value: 'createAt' }
      ],
      list2: {
        blockHash: '',
        blockHeight: '',
        previewHash: '',
        time: ''
      },
      title3: '合约执行信息',
      tableCol3: [
        { label: '合约目标', icon: targetImg, value: 'contractName' },
        {
          label: '合约调用入参',
          icon: paramsImg,
          value: 'contractName',
          slotName: 'paramsDetail',
          className: 'params-detail'
        },
        { label: '合约读写集哈希', icon: contractHashImg, value: 'rwSetHash' },
        {
          label: '合约执行结果码',
          icon: resultImg,
          value: 'contractResultCode',
          formatter: data => `${data.contractResultCode}`,
          offset: 12,
          pull: 12
        },
        { label: '合约调用方法', icon: methodImg, value: 'contractMethod', offset: 12, pull: 12 }
      ],
      list3: {
        blockHash: '',
        blockHeight: '',
        previewHash: '',
        time: ''
      },
      labelList: [
        { label: '#', prop: 'id', minWidth: 68 },
        { label: 'Key', prop: 'key', minWidth: 173 },
        { label: 'Value', prop: 'value', minWidth: 180 }
      ],
      paramList: [],
      loading: true
    }
  },
  computed: {
    transParamList: function() {
      return this.paramList.map((e, index) => {
        return {
          id: `${index}`,
          key: e.key,
          value: e.value
        }
      })
    }
  },
  watch: {
    '$store.state.home.chainCid': {
      deep: true,
      handler() {
        this.getTxnListFn()
      }
    }
  },
  mounted() {
    this.getTxnListFn()
  },
  methods: {
    ...mapActions(['getTxnLists']),
    getTxnListFn(limit = 10, offset = 0) {
      let params = {
        offset,
        limit,
        chainId: this.$route.query.chainId || this.$store.state.home.chainCid,
        txId: this.$route.query.txId
      }
      this.getTxnLists(params).then(res => {
        if (res.items[0]) {
          this.list1 = this.list2 = this.list3 = res.items[0]
          this.paramList = JSON.parse(res.items[0].contractParameters)

          this.$apis.configmanage
            .getPersonConfig()
            .then(res => {
              if (res?.data) {
                let isDecode = res.data.txValueDecode
                if (isDecode) {
                  this.paramList.forEach((item, index) => {
                    // CONTRACT_BYTECODE字段不用解码
                    if (item.key !== 'CONTRACT_BYTECODE') {
                      item.value = Base64.decode(item.value)
                    }
                  })
                }
              }
            })
            .catch(err => {
              this.loading = false
            })
          // if (this.$store.state.app.decodeValue) {
          //   this.paramList.forEach((item, index) => {
          //     //item.value = btoa(encodeURIComponent(item.value))
          //     //item.value = decodeURIComponent(atob(item.value))
          //     item.value = Base64.decode(item.value)
          //   })
          //   console.log(this.paramList)
          // }
        }
        this.loading = false
      })
    },
    handleToHomeChart() {
      this.$router.push('../dataAnalysis')
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

@include theme('home-tx-detail', (), ());
.home-tx-detail {
  @include adaptation(
    (
      --home-tx-detail-contract-params-height: 70px,
      --home-tx-detail-unavailable-height: 48px,
      --home-tx-detail-item-height: 70px
    )
  );

  .cbaas-detail-table {
    /deep/ {
      .detail-item {
        height: var(--home-tx-detail-item-height);
      }
    }
  }

  .common-bg-plate {
    min-height: calc(var(--base-main-router-body-avaliable-height) - var(--home-tx-detail-unavailable-height));
    &.no-action-bar {
      min-height: var(--base-main-router-body-avaliable-height);
    }
  }

  .cbaas-detail-table {
    /deep/ {
      .el-col.params-detail {
        height: var(--home-tx-detail-contract-params-height);
        .detail-item {
          .right {
            width: 100%;
          }
        }
      }
    }
  }
}
</style>
